import { IsString, IsOptional, MaxLength } from "class-validator";

export class SystemErrorLogInputDTO {
	@MaxLength(256)
	@IsString()
	@IsOptional()
	message?: string;

	@MaxLength(5112)
	@IsString()
	@IsOptional()
	stack?: string;

	@MaxLength(512)
	@IsString()
	@IsOptional()
	href?: string;
}
